import request from './request'

export function summitSubscribe(parameter) {
  return request({
    url: '/api/reserve/subscribe',
    method: 'post',
    data: parameter
  })
}

export function lottery(parameter) {
  return request({
    url: '/api/reserve/wheel',
    method: 'post',
    data: parameter
  })
}

export function event(parameter) {
  return request({
    url: '/api/reserve/event',
    method: 'post',
    data: parameter
  })
}

export function getUserInfo(parameter) {
  return request({
    url: '/users/v1.0/role_query',
    method: 'post',
    data: parameter
  })
}

export function getItems(parameter) {
  return request({
    url: '/orders/v1.0/products',
    method: 'post',
    data: parameter
  })
}

export function pay(parameter) {
  return request({
    url: '/orders/v1.0/web',
    method: 'post',
    data: parameter
  })
}

export function getModules(parameter) {
  return request({
    url: '/api/forum/modules',
    method: 'get',
    params: parameter
  })
}

export function getArticles(parameter) {
  return request({
    url: '/api/forum/articles',
    method: 'get',
    params: parameter
  })
}

export function getArticleDetail(parameter) {
  return request({
    url: '/api/forum/articles/' + parameter,
    method: 'get'
  })
}